module.exports = __webpack_public_path__ + "5942.8d7193ef447d0a7625838cb68741f432.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/5942.png
// module id = 191
// module chunks = 0